import {FC} from "react";
import {IconComponent} from "../script-injector";
import {PlaceholderProps} from "./PlaceholderProps";

export const DefaultPlaceholder: FC<PlaceholderProps> = () => {
  return (
    <div className={"custom-element-placeholder"}>
      <IconComponent color={"rgba(5, 133, 200, 0.1)"} />
    </div>
  );
};
